import type { ReactElement } from 'react';

export const Header = (): ReactElement => (
  <div className='d-flex justify-content-between align-items-center mb-24px pb-8px border-bottom'>
    <h1 className='m-0'>Contact Us</h1>
  </div>
);
